<template>
  <div class="ilan-container">
    <img class="bg-image" src="/static/images/ilan/bg.png" />
    <img class="bg-logo" src="/static/images/ilan/bg-logo.png" />
    <img class="logo" src="/static/images/ilan/logo.png" />
    <img class="ch-system" src="/static/images/ilan/ch-system.png" />
    <img class="en-system" src="/static/images/ilan/en-system.png" />
    <img class="sanjiao" src="/static/images/ilan/sanjiao.png" />
    <div class="text-content">防伪查询<span class="dot">·</span>点击扫码</div>
    <img class="jubao-icon" src="/static/images/ilan/jubao-icon.png" @click="goToReport" />
    <img class="scan-image" src="/static/images/ilan/scan.png" @click="handleScan" />
  </div>
</template>

<script>
import { getJSSDK } from '../../api/api'
import wx from 'weixin-js-sdk'

export default {
  name: 'ILanIndex',
  data() {
    return {
      appId: process.env.ENV_NUM === '1' ? 'wxbc22565b3e7a59fd' : 'wxbc22565b3e7a59fd'
    }
  },
  mounted() {
    this.getWxJs()
  },
  methods: {
    goToReport() {
      this.$router.push('/ilan/report')
    },
    handleScan() {
      wx.scanQRCode({
        needResult: 1,
        scanType: ["qrCode", "barCode"],
        success: res => {
          var scanResult = res.resultStr
          var scanQRCode = scanResult
          if (scanResult.startsWith('http')) {
            let parts = scanResult.split('?');
            scanQRCode = parts.length > 1 ? parts[1] : '';
          }
          this.navigateToResult(scanQRCode)
        }
      });
    },
    navigateToResult(code) {
      this.$router.push({
        path: '/ilan/result',
        query: { c: code }
      })
    },
    getWxJs() {
      const url = encodeURIComponent(window.location.href.split('#')[0])
      getJSSDK(url, this.appId).then(res => {
        const data = res.data.data
        wx.config({
          debug: false,
          appId: data.appId,
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature,
          openTagList: ["wx-open-launch-weapp", "wx-open-launch-app"],
          jsApiList: [
            'checkJsApi',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'hideMenuItems',
            'showMenuItems',
            'hideAllNonBaseMenuItem',
            'showAllNonBaseMenuItem',
            'translateVoice',
            'startRecord',
            'stopRecord',
            'onVoiceRecordEnd',
            'playVoice',
            'onVoicePlayEnd',
            'pauseVoice',
            'stopVoice',
            'uploadVoice',
            'downloadVoice',
            'chooseImage',
            'previewImage',
            'uploadImage',
            'downloadImage',
            'getNetworkType',
            'openLocation',
            'getLocation',
            'hideOptionMenu',
            'showOptionMenu',
            'closeWindow',
            'scanQRCode',
            'chooseWXPay',
            'openEnterpriseChat',
            'openCustomerService'
          ]
        })
      })
    }
  }
}
</script>

<style scoped>
.ilan-container {
  width: 100vw;
  height: 100vh;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.bg-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 1;
}

.bg-logo {
  position: absolute;
  top: 8vh;
  left: 50%;
  width: 80vw;
  transform: translateX(-50%);
  z-index: 2;
}

.logo {
  position: absolute;
  top: 11vh;
  left: 50%;
  width: 33vw;
  transform: translateX(-50%);
  z-index: 3;
}

.ch-system {
  position: absolute;
  top: 20vh;
  left: 50%;
  width: 60vw;
  transform: translateX(-50%);
  z-index: 2;
}

.en-system {
  position: absolute;
  top: 24.5vh;
  left: 50%;
  width: 60vw;
  transform: translateX(-50%);
  z-index: 2;
}

.sanjiao {
  position: absolute;
  top: 70vh;
  left: 50%;
  width: 7vw;
  transform: translateX(-50%);
  z-index: 2;
}

.text-content {
  position: absolute;
  top: 75vh;
  left: 50%;
  transform: translateX(-50%);
  color: white;
  font-size: 4.5vw;
  font-weight: 900;
  z-index: 2;
  display: flex;
  align-items: center;
  gap: 1vw;
}

.dot {
  font-size: 5vw;
}

.jubao-icon {
  position: absolute;
  bottom: 9vh;
  width: 12vw;
  left: 10vw;
  z-index: 2;
  cursor: pointer;
}

.scan-image {
  position: relative;
  z-index: 2;
  width: 12vw;
  height: 12vw;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/ILan/Index.vue